import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { ShipmentService } from '../shipment.service';
import { EnumsService, Preferences } from '@library/core/services';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
   selector: 'shipment-cod',
   templateUrl: './cod.component.html',
   styleUrls: ['./cod.component.scss']
})
export class CodComponent implements OnInit, OnDestroy {
   _onDestroy: Subject<void> = new Subject();

   config;

   cod: FormGroup;

   private _amount: FormControl;
   private _currency: FormControl;

   constructor(
      public shipment: ShipmentService,
      public enums: EnumsService,
      private prefs: Preferences,
   ) { }

   // comment
   ngOnInit() {
      this.shipment.shipmentUpdate$.pipe(
         map(() => this.shipment.shipmentForm.get('cod')),
         takeUntil( this._onDestroy ),
      ).subscribe( cod => {
         this.cod = cod as FormGroup;
         this._amount = this.cod.get('amount') as FormControl;
         this._currency = this.cod.get('currency') as FormControl;
         this.config = this.shipment?.configs?.cod;
         
         this.cod.get('type').patchValue(this.cod.get('type').value);
         this.cod.get('type').valueChanges.subscribe( val => {
            if ( val == 'other' ) {
               this.otherOption();
            } else if ( val == 'check' ) {
               this.valueOption();
            }
         });
      });
   }

   ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
   }

   resetOption() {
      this.cod.reset();
      if ( this.cod.contains('amount') ) {
         this.cod.removeControl('amount');
         this.cod.removeControl('currency');
      }
      this.cod.updateValueAndValidity();
   }

   otherOption() {
      if ( this.cod.contains('amount') ) {
         this.cod.removeControl('amount');
         this.cod.removeControl('currency');
      }

      this.cod.updateValueAndValidity();
   }

   valueOption() {
      if ( !this.cod.contains('amount') ) {
         this.cod.addControl('amount', this._amount);
         this.cod.addControl('currency', this._currency);
      }

      this._currency.setValue( this._currency.value ?? this.prefs.getPref( 'currency' ));

      this.cod.updateValueAndValidity();
   }
}
